module.exports = __webpack_public_path__ + "img/POP-00013-2.6db9388b.png";